import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownItem } from '../Dropdown';

var MobileFilter = function MobileFilter(_ref) {
  var filters = _ref.filters,
      selectedIdx = _ref.selectedIdx,
      onChange = _ref.onChange,
      label = _ref.label;
  return /*#__PURE__*/React.createElement(Dropdown, {
    className: "margintop-md",
    defaultText: label,
    onChange: onChange,
    dynamicDropDirection: true,
    size: "medium",
    value: selectedIdx > -1 ? filters[selectedIdx].name : null,
    panelHeight: 240
  }, filters.map(function (menuItem) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: menuItem.name,
      itemText: menuItem.name,
      value: menuItem.name
    });
  }));
};

MobileFilter.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    endDate: PropTypes.object,
    startDate: PropTypes.object
  })).isRequired,
  selectedIdx: PropTypes.number,
  onChange: PropTypes.func.isRequired,

  /** Label for preset dates (smart dates) section */
  label: PropTypes.string
};
MobileFilter.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MobileFilter",
  "props": {
    "filters": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "endDate": {
              "name": "object",
              "required": false
            },
            "startDate": {
              "name": "object",
              "required": false
            }
          }
        }
      },
      "required": true,
      "description": ""
    },
    "selectedIdx": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label for preset dates (smart dates) section"
    }
  }
};
export default MobileFilter;